import React from "react";
import { ConfigProvider } from "antd";
import { lightTheme } from "./theme";
import NavigationManager from "./NavigationManager";
import { localStorageUtil } from "./utils/CommonFunctions";
import { SocketProvider } from "./Context/SocketContext";

const App = () => {
  const UserData = localStorageUtil.getItem("userData");

  return (
    <SocketProvider user={UserData}>
      <ConfigProvider theme={lightTheme}>
        <NavigationManager />
      </ConfigProvider>
    </SocketProvider>
  );
};

export default App;
